import { useState } from 'react';
import { CertificationPeriodDischargePlans } from '~/features/discharge/CertificationPeriodDischargePlans';

import { Tabs } from '~/shared/components/tabs/Tabs';
import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';

export function CertificationPeriodPlanOfCare({ certificationPeriodId }: { certificationPeriodId: string }) {
	const [selectedView, setSelectedView] = useState<string>('overview');

	return (
		<Section header={<SectionTitle title="Plan of Care" />}>
			<div className="mb-4">
				<Tabs selectedKey={selectedView} onSelectionChange={(newView: string) => setSelectedView(newView)}>
					<Tabs.TabList>
						<Tabs.Tab id="overview">Overview</Tabs.Tab>
						<Tabs.Tab id="dx">Dx</Tabs.Tab>
						<Tabs.Tab id="discharge-plans">Discharge Plans</Tabs.Tab>
					</Tabs.TabList>
					<Tabs.TabPanel id="overview">
						<p>Overview content goes here</p>
					</Tabs.TabPanel>
					<Tabs.TabPanel id="discharge-plans" className="p-4">
						<CertificationPeriodDischargePlans certificationPeriodId={certificationPeriodId} />
					</Tabs.TabPanel>
				</Tabs>
			</div>
		</Section>
	);
}
